import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export const departmentCategories = (
  state = initialState.departmentCategories,
  action
) => {
  switch (action.type) {
    case types.LOAD_DEPARTMENT_CATEGORY_SUCCESS:
      return action.departmentCategories;

    default:
      return state;
  }
};

export const departmentCategory = (
  state = initialState.departmentCategory,
  action
) => {
  switch (action.type) {
    case types.GET_DEPARTMENT_CATEGORY_SUCCESS:
      return action.departmentCategory;

    default:
      return state;
  }
};
